<template>
  <div class="supplementBox">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      class="supplementDialog"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <div class="contentBox" v-for="(item, index) in tableList" :key="index">
        <div class="topBox" :class="type">
          <div>
            <div class="fileName" v-show="item.fileName">
              {{ item.fileName }}
              <span v-if="item.popover" class="popover">
                ({{ item.popover }})
              </span>
            </div>
          </div>
          <el-button
            type="primary"
            :disabled="disabled"
            round
            v-show="
              stopUploadingFlag &&
                permission_btns.includes(codeObject.updateFileCode)
            "
            @click="uploadReport(item)"
            >{{ item.uploadReportName }}</el-button
          >
        </div>
        <SrTable
          :data="item.dataList"
          :config="item.table.tableConfig"
          :page="item.table.page"
          class="SrTable"
          ref="SrTable"
        >
          <template slot="cellSlot" slot-scope="scope">
            <div
              class="fileNameBox hid"
              @click="see(scope.scope.row)"
              v-if="scope.scope.item.prop == 'fileName'"
            >
              <span>
                <i class="base-iconfont icon-attachent"></i>
                {{ scope.scope.row.fileName }}</span
              >
            </div>
          </template>
        </SrTable>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          v-if="permission_btns.includes(codeObject.stopUploadingCode)"
          class="stopUploading"
          :class="!stopUploadingFlag ? 'disabled' : ''"
          @click="stopUploading"
        >
          <i
            :class="
              stopUploadingIcon ? stopUploadingIcon : `base-iconfont icon-block`
            "
          ></i>
          {{
            stopUploadingFlag
              ? stopUploadingPassedName
              : stopUploadingStoppedName
          }}
        </div>
        <el-button round @click="close">关 闭</el-button>
      </span>
    </el-dialog>
    <SrBigUpload
      v-show="false"
      ref="srUpload"
      @uploadSuccess="
        data => {
          BigFileUploadSuccess(data);
        }
      "
      @onFileError="
        data => {
          BigFileUploadError(data);
        }
      "
      @startUpload="
        data => {
          BigFileUploadStart(data);
        }
      "
      :fileList="fileList"
    >
    </SrBigUpload>
    <el-dialog
      title="历史版本"
      :visible.sync="historicalVersionVisible"
      width="800px"
      class="supplementDialog"
    >
      <SrTable
        :data="tableDialog.data"
        :config="tableDialog.tableConfig"
        ref="tableDialog"
        @pageChanged="pageChanged"
        @sizeChanged="sizeChanged"
      >
        <template slot="cellSlot" slot-scope="scope">
          <div
            class="fileNameBox hid"
            @click="see(scope.scope.row)"
            v-if="scope.scope.item.prop == 'fileName'"
          >
            <span>
              <i class="base-iconfont icon-attachent"></i>
              {{ scope.scope.row.fileName }}</span
            >
          </div>
        </template>
      </SrTable>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SrSupplementBox",
  inject: ["baseUrl"],
  props: {
    tableDataList: {
      type: Array,
      default() {
        return [
          {
            fileName: "申报附件",
            //文件提示
            popover: "11111111",
            uploadReportName: "上传报告",
            //列表数据
            dataList: [],
            instanceId: ""
          }
        ];
      }
    },
    stopUploadingPassedName: {
      type: String,
      default() {
        return "停止上传";
      }
    },
    stopUploadingStoppedName: {
      type: String,
      default() {
        return "已停止上传";
      }
    },
    title: {
      type: String,
      default() {
        return "补充文件";
      }
    },
    //停止上传
    stopUploadingFlag: {
      type: Boolean,
      default() {
        return true;
      }
    },
    stopUploadingIcon: {
      type: String,
      default() {
        return "";
      }
    },
    menuTypeObject: {
      type: Object,
      default() {
        return {
          menuType: null,
          objectId: null,
          projectId: null
        };
      }
    },
    codeObject: {
      type: Object,
      default() {
        return {
          //上传文件权限code
          updateFileCode: "",
          //删除code
          deleteCode: "",
          //停止上传code
          stopUploadingCode: ""
        };
      }
    },
    apiObject: {
      type: Object,
      default() {
        return {
          api_getTestInstanceId: "",
          api_addFile: "",
          api_updateFile: "",
          api_listByInstanceId: "",
          api_deleteItem: ""
        };
      }
    },
    type: {
      type: String,
      default() {
        return "planedProject";
      }
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      timeout: "",
      disabled: false,
      fileList: [],
      historicalVersionItem: {},
      dialogVisible: false,
      historicalVersionVisible: false,
      otherConfig: {
        labelNum: 200
      },
      activeItem: {},
      instanceId: 1,
      updateFileItem: "",
      tableList: [],
      table: {
        data: [], // 表格数据
        tableConfig: {
          title: "表格的标题", // 表格标题
          highlightCurrentRow: false, // 控制表格是否单选
          maxHeight: "400px",
          // maxLength: 20, // 一行最多显示多少字，超出显示popver
          tooltipEffect: "light",
          header: [
            // 表格列配置
            {
              label: "附件",
              prop: "fileName",
              width: "200px",
              cellSlot: true
            },
            {
              label: "上传人",
              prop: "createName"
            },
            {
              label: "上传时间",
              prop: "createTime",
              width: "160px"
            }
          ],
          indexConfig: {
            display: true,
            label: "序号",
            width: "70"
          },
          emptyConfig: {
            // 表格数据为空时默认显示的内容
            display: true,
            emptyNull: "暂无项目",
            emptyTip: "立即"
          },
          operateConfig: {
            display: true,
            label: "操作",
            width: "220",
            fixed: "right"
            // export: this.export,
            // exportPermissionCode:'M002_001_002'
          },
          innerBtn: [
            // 表格内部操作按钮，不需要操作列的innerBtn 写成false
            {
              name: "更新文件", // 按钮名称，优先显示icon
              type: "text",
              size: "small",
              method: "updateFile", // 点击执行该页面methods中对应的方法
              validate: this.btnValidate //自定义判断是否展示按钮权限
            },
            {
              name: "下载",
              method: "toDwon",
              type: "text",
              className: "font-size-20"
            },
            {
              name: "历史版本",
              method: "historicalVersion",
              type: "text"
            },
            {
              name: "删除",
              method: "delete",
              type: "text",
              validate: this.btnValidate
            }
          ]
        },
        page: {
          // 分页配置
          total: 0, //总条数
          pages: 0, //总页数
          pageSize: 10, //每页展示多少个
          pageSizes: [10, 20, 30],
          pageNum: 1, //当前页
          background: true
        }
      },
      tableDialog: {
        data: [], // 表格数据
        tableConfig: {
          title: "表格的标题", // 表格标题
          highlightCurrentRow: false, // 控制表格是否单选
          maxHeight: "400px",
          // maxLength: 20, // 一行最多显示多少字，超出显示popver
          tooltipEffect: "light",
          header: [
            // 表格列配置
            {
              label: "附件名称",
              prop: "fileName",
              cellSlot: true
            },
            {
              label: "大小",
              prop: "size"
            },
            {
              label: "上传人",
              prop: "createName",
              className: "name"
            },
            {
              label: "上传时间",
              prop: "createTime",
              width: "160"
            }
          ],
          indexConfig: {
            display: true,
            label: "序号",
            width: "70"
          },
          operateConfig: {
            display: true,
            label: "操作",
            width: "160",
            fixed: "right",
            export: this.export
            // exportPermissionCode:'M002_001_002'
          },
          emptyConfig: {
            // 表格数据为空时默认显示的内容
            display: true,
            emptyNull: "暂无项目",
            emptyTip: "暂无附件"
          },
          innerBtn: [
            // 表格内部操作按钮，不需要操作列的innerBtn 写成false
            {
              name: "查看", // 按钮名称，优先显示icon
              type: "text",
              size: "small",
              method: "see" // 点击执行该页面methods中对应的方法
            },
            {
              name: "下载",
              method: "toDwon",
              type: "text"
            }
          ]
        },
        page: {
          // 分页配置
          total: 0, //总条数
          pages: 0, //总页数
          pageSize: 10, //每页展示多少个
          pageSizes: [10, 20, 30],
          pageNum: 1, //当前页
          background: true
        }
      }
    };
  },
  mounted() {
    this.fullscreenLoading = false;
  },
  created() {},
  computed: {
    permission_btns: function() {
      return JSON.parse(sessionStorage.getItem("permission_btns") || "[]").map(
        res => {
          return res.permissionCode;
        }
      );
    }
  },
  watch: {
    tableDataList: {
      handler: function(params) {
        if (params && params.length) {
          this.init();
        }
      },
      deep: true
    },
    stopUploadingFlag: {
      handler: function(params) {
        this.init();
      }
    }
  },
  methods: {
    getfilesize(size) {
      if (!size) return "";

      var num = 1024.0; //byte

      if (size < num) return size + "B";
      if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + "KB"; //kb
      if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
      if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    },
    formatData(date, format) {
      let time = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S+": date.getMilliseconds()
      };
      if (/(y+)/i.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (let k in time) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? time[k]
              : ("00" + time[k]).substr(("" + time[k]).length)
          );
        }
      }
      return format;
    },
    btnValidate(row, item) {
      if (
        row.name == "更新文件" &&
        this.stopUploadingFlag &&
        this.permission_btns.includes(this.codeObject.updateFileCode)
      ) {
        return false;
      } else if (
        row.name == "删除" &&
        this.stopUploadingFlag &&
        this.permission_btns.includes(this.codeObject.deleteCode)
      ) {
        return true;
      }
      return false;
    },
    see(file) {
      let token = sessionStorage.getItem("token");
      if (
        [
          "txt",
          "ppt",
          "pptx",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "html",
          "pdf"
        ].includes(file.fileName.split(".").pop())
      ) {
        window.open(`${this.baseUrl}/viewPdf?id=${file.fileId}`);
      } else {
        window.open(
          `${this.baseUrl}/jfzg/file/api/file/download?key=${file.fileId}&access_token=${token}`
        );
      }
    },
    //下载
    toDwon(file) {
      let token = sessionStorage.getItem("token");
      window.open(
        `${this.baseUrl}/jfzg/file/api/file/downloadStream?key=${file.fileId}&access_token=${token}`
      );
    },
    // 上传文件
    BigFileUploadSuccess(fileList) {
      this.fullscreenLoading = false;
      if (this.updateFileItem) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setUpdateFile(fileList);
        }, 100);
      } else {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.addFile(fileList);
        }, 100);
      }
      this.fileList = [];
    },
    BigFileUploadError(item) {
      this.fullscreenLoading = false;
      console.log(item);
    },
    BigFileUploadStart(item) {
      console.log("BigFileUploadStart", item);
      this.fullscreenLoading = item;
    },
    setUpdateFile(fileList) {
      let params = {
        itemId: this.updateFileItem.itemId,
        fileId: fileList[0].id,
        fileName: fileList[0].name,
        size: fileList[0].size,
        instanceId: this.updateFileItem.instanceId
      };
      if (this.menuTypeObject && this.menuTypeObject.menuType) {
        params.menuType = this.menuTypeObject.menuType;
      }
      if (this.menuTypeObject && this.menuTypeObject.objectId) {
        params.objectId = this.menuTypeObject.objectId;
      }
      if (this.menuTypeObject && this.menuTypeObject.projectId) {
        params.projectId = this.menuTypeObject.projectId;
      } else {
        params.projectId = null;
      }
      this.apiObject.api_updateFile(params).then(res => {
        if (res.msg.code == "0000") {
          this.updateFileItem = "";
          this.init();
        }
      });
    },
    addFile(fileList) {
      let params = {
        instanceId: this.activeItem.instanceId,
        fileId: fileList[0].id,
        fileName: fileList[0].name,
        size: fileList[0].size,
        itemId: this.activeItem.itemId
      };
      if (this.menuTypeObject && this.menuTypeObject.menuType) {
        params.menuType = this.menuTypeObject.menuType;
      }
      if (this.menuTypeObject && this.menuTypeObject.objectId) {
        params.objectId = this.menuTypeObject.objectId;
      }
      if (this.menuTypeObject && this.menuTypeObject.projectId) {
        params.projectId = this.menuTypeObject.projectId;
      } else  {
        params.projectId = null
      }
      this.apiObject.api_addFile(params).then(res => {
        if (res.msg.code == "0000") {
          this.activeItem = {};
          this.init();
        }
      });
    },
    //初始化
    init() {
      if (this.tableDataList && this.tableDataList.length) {
        let list = JSON.parse(JSON.stringify(this.tableDataList));
        list.forEach((item, index) => {
          let table = JSON.parse(JSON.stringify(this.table));
          if (
            !(
              this.stopUploadingFlag &&
              this.permission_btns.includes(this.codeObject.updateFileCode)
            )
          ) {
            table.tableConfig.innerBtn = table.tableConfig.innerBtn.filter(
              item1 => {
                return item1.name != "更新文件";
              }
            );
          }
          if (
            !(
              this.stopUploadingFlag &&
              this.permission_btns.includes(this.codeObject.deleteCode)
            )
          ) {
            table.tableConfig.innerBtn = table.tableConfig.innerBtn.filter(
              item1 => {
                return item1.name != "删除";
              }
            );
          }
          table.tableConfig.emptyConfig.emptyTip = item.fileName
            ? "暂无" + item.fileName
            : "暂无" + this.title;
          item.table = table;
          item.instanceId = item.instanceId;
          if (this.apiObject.api_listByInstanceId) {
            this.apiObject.api_listByInstanceId(item.instanceId).then(res => {
              if (res.msg.code == "0000") {
                item.dataList = res.data.map(item1 => {
                  item1.createTime = this.formatData(
                    new Date(item1.createTime),
                    "YYYY-MM-dd hh:mm"
                  );
                  item1.instanceId = item.instanceId || this.instanceId;
                  return item1;
                });
              }
            });
          }
        });
        this.tableList = list;
      }
      this.dialogVisible = true;
    },
    //
    submint() {
      this.dialogVisible = false;
      this.$emit("submint");
    },
    close() {
      this.fileList = [];
      this.activeItem = {};
      this.updateFileItem = "";
      this.dialogVisible = false;
    },
    updateFile(item) {
      console.log(item,'updateFileItem');
      this.updateFileItem = item;
      this.uploadReport();
    },
    delete(item) {
      this.$SrUtils.showConfirmMessage.call(this, {
        title: "提示",
        content: "此操作将删除此文件, 是否继续?",
        okFun: () => {
          let params = {
            instanceId: item.instanceId,
            itemId: item.itemId,
            historyId: item.itemId
          };
          if (this.menuTypeObject && this.menuTypeObject.menuType) {
            params.menuType = this.menuTypeObject.menuType;
          }
          if (this.menuTypeObject && this.menuTypeObject.objectId) {
            params.objectId = this.menuTypeObject.objectId;
          }
          if (this.menuTypeObject && this.menuTypeObject.projectId) {
            params.projectId = this.menuTypeObject.projectId;
          } else  {
            params.projectId = null
          }
          this.apiObject.api_deleteItem(params).then(res => {
            if (res && res.success) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.init();
            }
          });
        },
        cancelFun: () => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        }
      });
    },
    historicalVersion(item) {
      // this.historicalVersionItem = item
      this.initTableDialog(item);
      this.historicalVersionVisible = true;
    },
    emptyClick() {},
    //上传
    uploadReport(item) {
      this.activeItem = item;
      let btn = document.getElementsByClassName("uploader-btn");
      btn[0].click();
    },
    //停止上传
    stopUploading() {
      if (!this.stopUploadingFlag) {
        return;
      }
      this.$SrUtils.showConfirmMessage.call(this, {
        title: "停止上传",
        content:
          "请确认是否停止上传，停止后将不能上传建设方案等文件，该操作无法撤回。",
        okFun: () => {
          this.$emit("stopUploading", this.tableDataList);
        },
        cancelFun: () => {
          this.$message({
            type: "info",
            message: "已取消停止"
          });
        }
      });
    },
    historicalVersionVisibleClose() {
      this.tableDialog.data = [];
      this.historicalVersionVisible = false;
    },
    initTableDialog(index) {
      // if (index) {
      //   this.tableDialog.page.pageNum = index;
      // }
      // let params = {
      //   pageNum: this.tableDialog.page.pageNum,
      //   pageSize: this.tableDialog.page.pageSize,
      // };
      let list = JSON.parse(JSON.stringify(index));
      this.tableDialog.data = list.files.map(item => {
        item.size = this.getfilesize(item.size);
        item.createTime = this.formatData(
          new Date(item.createTime),
          "YYYY-MM-dd hh:mm"
        );
        return item;
      });
    },
    //页数发生改变
    pageChanged(val) {
      this.tableDialog.page.pageNum = val;
      this.initTableDialog();
    },
    // 修改每页展示多少条
    sizeChanged(val) {
      this.tableDialog.page.pageNum = 1;
      this.tableDialog.page.pageSize = val;
      this.initTableDialog();
    }
  }
};
</script>



// WEBPACK FOOTER //
// packages/SrSupplementBox/index.vue